import { render } from "./News03.vue?vue&type=template&id=173c32d3&scoped=true"
import script from "./News03.vue?vue&type=script&lang=js"
export * from "./News03.vue?vue&type=script&lang=js"

import "./News03.vue?vue&type=style&index=0&id=173c32d3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173c32d3"]])

export default __exports__